// extracted by mini-css-extract-plugin
module.exports = {"numbersWrapper":"styles_numbersWrapper__2oOWx","sectionName":"styles_sectionName__2ejbj","medium":"styles_medium__1s5Bb","big":"styles_big__1GX4k"};